<div class="notifications-dropdown-container">
  <!-- Bell Icon with Badge -->
  <div class="notifications-trigger" (click)="onToggleDropdown($event)">
    <div class="bell-icon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22ZM18 16V11C18 7.93 16.37 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.64 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16ZM16 17H8V11C8 8.52 9.51 6.5 12 6.5C14.49 6.5 16 8.52 16 11V17Z" fill="currentColor"/>
      </svg>
      <!-- Badge for unread count -->
      <div class="notifications-badge" *ngIf="unreadCount > 0">
        <span>{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
      </div>
    </div>
  </div>

  <!-- Dropdown Panel -->
  <div class="notifications-dropdown" [class.open]="isOpen">
    <div class="dropdown-header">
      <h4>Notifications</h4>
      <button class="close-btn" (click)="onToggleDropdown($event)">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor"/>
        </svg>
      </button>
    </div>

    <div class="dropdown-content">
      <!-- Notifications List -->
      <div class="notifications-list" *ngIf="notify.length > 0">
        <div class="notification-item" *ngFor="let notification of notify">
          <div class="notification-content">
            <div class="notification-title">{{ notification.product_name }}</div>
            <div class="notification-shipment" *ngIf="notification.shipment_id">
              Shipment ID {{ notification.shipment_id }}
            </div>
            <div class="notification-meta">
              <ng-container *ngIf="notification.store_name">
                {{ notification.store_name }} |
              </ng-container>
              Status:
              <span class="status-text" [class]="notification.status">
                {{ notification.status }}
              </span>
            </div>
          </div>
          <div class="notification-date">
            {{ timestampFormat(notification.updated_at, "DD/MM/YYYY") }}
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div class="empty-state" *ngIf="notify.length === 0">
        <div class="empty-icon">🔔</div>
        <p>No new notifications</p>
      </div>

      <!-- View All Link -->
      <div class="view-all-section" *ngIf="notify.length > 0">
        <a class="view-all-link" (click)="navigateToNotifyList($event)">View All Notifications</a>
      </div>
    </div>
  </div>
</div> 